import { useEffect, useRef, useState } from 'react';
import api from '@/lib/axios';
import { useAuth } from '@/context/AuthProvider';
import { OPERATIONAL_CONTEXT_EVENT } from '@/lib/procurementOperationalContext';
export function useFinancialCaptureContext() {
  const { user } = useAuth(), [revision, setRevision] = useState(0);
  const identity = JSON.stringify([user?.id,user?.company_id,user?.unit_id,user?.role,user?.is_platform_admin,user?.permissions,revision]);
  const current = useRef(identity); current.current = identity;
  const [state,setState] = useState({ key:'',data:null,loading:true,error:'',legacy:false });
  useEffect(() => {
    const changed=()=>setRevision(n=>n+1);window.addEventListener(OPERATIONAL_CONTEXT_EVENT,changed);
    return()=>window.removeEventListener(OPERATIONAL_CONTEXT_EVENT,changed);
  },[]);
  useEffect(() => {
    const controller = new AbortController();let alive=true;
    setState({key:identity,data:null,loading:true,error:'',legacy:false});
    (async()=>{
      try {
        if (!user?.id) throw new Error('Sign in to continue.');
        let company=user.company_id,unit=user.unit_id;
        if(user.is_platform_admin===true){const selected=(await api.get('/admin/context',{signal:controller.signal})).data?.context;company=selected?.company_id;unit=selected?.unit_id;}
        if(!company||!unit)throw new Error('Select a unit before continuing.');
        const data=(await api.get('/reporting/unit/financial-capture-capabilities',{signal:controller.signal})).data;
        if(data?.version!==1||data.scope?.user_id!==user.id||data.scope?.company_id!==Number(company)||data.scope?.unit_id!==Number(unit)||
          !Array.isArray(data.currencies)||data.currencies.some(c=>typeof c!=='string'||!/^[A-Z]{3}$/.test(c)))throw new Error('The financial context could not be verified.');
        if(alive&&current.current===identity)setState({key:identity,data,loading:false,error:'',legacy:false});
      }catch(error){if(alive&&!controller.signal.aborted&&current.current===identity)setState({key:identity,data:null,loading:false,
        legacy:error?.response?.status===404,error:error?.response?.status===404?'':'Financial settings are unavailable for this account or unit. Refresh before continuing.'});}
    })();
    return()=>{alive=false;controller.abort();};
  },[identity]);
  return { ...(state.key===identity?state:{data:null,loading:true,error:'',legacy:false}), identity };
}
